import { Navigate, Route, Routes, useLocation } from "react-router";
import { AppShell } from "./components/AppShell";
import { ContactPage } from "./pages/ContactPage";
import { HomePage } from "./pages/HomePage";
import { InfoPage } from "./pages/InfoPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ProjectPage } from "./pages/ProjectPage";
import { ProjectsPage } from "./pages/ProjectsPage";

/**
 * The section moved from /projects to /games. Cloudflare serves 301s for the
 * known slugs (see public/_redirects); this catches anything else — old links,
 * bookmarks, slugs added after that file was written.
 */
function LegacyProjectsRedirect() {
  const { pathname, search, hash } = useLocation();

  return (
    <Navigate
      to={`${pathname.replace(/^\/projects/, "/games")}${search}${hash}`}
      replace
    />
  );
}

export default function App() {
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/info" element={<InfoPage />} />
        <Route path="/games" element={<ProjectsPage />} />
        <Route path="/games/:slug" element={<ProjectPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/projects/*" element={<LegacyProjectsRedirect />} />
        <Route path="/projects" element={<LegacyProjectsRedirect />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AppShell>
  );
}
